
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Thirtifiveseateracbus() {



    const cardData =
    {
        keyword: '35 Seater AC Bus On Rent in Pune',
        heading: 'Amruta Travels: 35 Seater AC Bus On Rent in Pune',
        headingDescription: 'Amruta Travels offers 35 Seater AC Bus on Rent in Pune, perfect for medium-sized group travel with a focus on comfort, convenience, and reliability. Whether it is a corporate tour, school/college trip, destination wedding, or weekend getaway, our 35-seater air-conditioned buses are ideal for both local and outstation travel.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

   "services": [
    {
      "name": "35 Seater AC Bus Hire in Pune",
      "description": "Amruta Travels offers 35-seater AC bus hire services in Pune, ideal for small group travel. Whether it’s a corporate event, school trip, or outstation journey, our buses offer a comfortable and pleasant travel experience."
    },
    {
      "name": "35 Seater AC Bus Rental in Pune",
      "description": "Rent a 35-seater AC bus from Amruta Travels in Pune for your next event or outing. Our buses provide ample space, air conditioning, and comfortable seating, making them perfect for any group travel."
    },
    {
      "name": "Rent 35 Seater AC Bus in Pune",
      "description": "Amruta Travels offers reliable 35-seater AC bus rentals in Pune. Whether you're planning a wedding, corporate outing, or group trip, our buses are the perfect solution for your transportation needs."
    },
    {
      "name": "35 Seater AC Bus for Corporate Event",
      "description": "For your next corporate event in Pune, rent a 35-seater AC bus. Perfect for group transportation, our buses are equipped with comfortable seating and air conditioning, ensuring your team travels in comfort and style."
    },
    {
      "name": "35 Seater AC Bus for Wedding",
      "description": "Make your wedding transportation seamless by hiring a 35-seater AC bus from Amruta Travels. Perfect for transporting wedding guests to venues, our buses are spacious and comfortable, ensuring a stress-free journey."
    },
    {
      "name": "35 Seater AC Bus for Picnic",
      "description": "Plan your next picnic with Amruta Travels’ 35-seater AC buses. With comfortable seating and air conditioning, our buses provide a perfect solution for transporting groups to picnic spots in and around Pune."
    }
  ],
  "tableData": [
    ["35 Seater AC Bus Hire in Pune", "35 Seater AC Bus Rental in Pune"],
    ["Rent 35 Seater AC Bus in Pune", "35 Seater AC Bus for Corporate Event"],
    ["35 Seater AC Bus for Wedding", "35 Seater AC Bus for Picnic"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious 35 Seater AC Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels provides 35 seater AC buses on rent in Pune, ideal for medium-sized group travel. Whether for corporate outings, weddings, school trips, or pilgrimage tours, our buses offer a smooth and air-conditioned travel experience with ample space and comfort."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Trips, Events, and Family Outings",
    "WhyChoosedescription": "Our 35 seater buses are suitable for transporting groups for various occasions like conferences, social functions, family tours, and educational trips. With luxury seating and onboard amenities, passengers enjoy a relaxed journey to both local and outstation destinations."
  },
  {
    "WhyChooseheading": "Air-Conditioned Buses with Modern Features",
    "WhyChoosedescription": "Each 35 seater bus is fully air-conditioned and equipped with pushback seats, LED lighting, music systems, overhead storage, and USB charging ports—ensuring a comfortable and enjoyable ride for all passengers."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Bus Rental Packages",
    "WhyChoosedescription": "We offer budget-friendly, transparent pricing for 35 seater AC bus rentals in Pune. All costs—including driver allowance, fuel, tolls, and taxes—are clearly outlined, so you won’t face any hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Reliable Travel",
    "WhyChoosedescription": "All our buses are driven by professional, licensed drivers with excellent knowledge of city and outstation routes. Safety, punctuality, and customer service are their top priorities, ensuring a secure and smooth journey for your group."
  },
  {
    "WhyChooseheading": "Ideal for Local and Outstation Destinations",
    "WhyChoosedescription": "Whether you’re planning a city tour, a one-day picnic, or an outstation trip to places like Shirdi, Lonavala, or Mahabaleshwar, our 35 seater AC buses are built for comfort and endurance—perfect for long hours on the road."
  },
  {
    "WhyChooseheading": "Flexible Booking and Easy Reservation Process",
    "WhyChoosedescription": "Booking a 35 seater AC bus with Amruta Travels is quick and hassle-free. Choose your travel dates, destination, and duration—we’ll handle the rest. We offer flexible rental plans based on hourly, daily, or trip-based requirements."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Assistance Anytime",
    "WhyChoosedescription": "Our dedicated customer support team is available round the clock to help with your booking, itinerary changes, and special requests. We ensure prompt assistance for a worry-free and organized travel experience."
  }
]



























    }

const faqData = [
  {
    question: 'Can I rent a 35-seater AC bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels provides 35-seater AC buses for rent in Pune, ideal for mid-sized groups traveling for corporate events, school trips, family functions, or outstation tours.',
  },
  {
    question: 'What amenities are available in the 35-seater AC bus?',
    answer: 'Our 35-seater AC buses are equipped with push-back seats, air conditioning, spacious interiors, reading lights, music systems, and ample luggage storage for a comfortable travel experience.',
  },
  {
    question: 'Is the 35-seater AC bus available for both local and outstation trips?',
    answer: 'Yes, you can rent our 35-seater AC buses for local travel within Pune or for long-distance outstation trips to destinations such as Lonavala, Shirdi, Mahabaleshwar, Goa, and more.',
  },
  {
    question: 'Do your rentals include a driver?',
    answer: 'Yes, every 35-seater AC bus rental from Amruta Travels comes with an experienced, courteous, and licensed driver to ensure safe and stress-free travel.',
  },
  {
    question: 'How much does it cost to rent a 35-seater AC bus in Pune?',
    answer: 'The cost depends on factors such as travel distance, duration, and itinerary. Typically, prices start from ₹30–₹38 per km. Contact us for a detailed, customized quote.',
  },
  {
    question: 'Is the 35-seater AC bus suitable for multi-day trips?',
    answer: 'Absolutely. Our 35-seater AC buses are ideal for both short and long trips, offering comfort and reliability for journeys lasting multiple days.',
  },
  {
    question: 'Are the buses regularly maintained and sanitized?',
    answer: 'Yes, all buses are thoroughly sanitized before each trip and maintained to the highest standards for cleanliness, safety, and comfort.',
  },
  {
    question: 'How do I book a 35-seater AC bus with Amruta Travels?',
    answer: 'You can book your bus directly through our website or by contacting our team. We offer quick and hassle-free booking assistance tailored to your travel needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rajesh Pawar',
    role: 'Event Manager, Pune',
    text: 'We booked a 35-seater AC bus from Amruta Travels for a corporate team outing. The bus was punctual, very comfortable, and the overall service was top-notch.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meenal Jagtap',
    role: 'School Principal',
    text: 'Amruta Travels provided us with a 35-seater AC bus for a school trip. The bus was clean and spacious, and the driver was very professional. The students and staff were all happy!',
    rating: 5,
  },
];


















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const acBus35SeaterSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "35 Seater AC Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/35-seater-ac-bus.jpg", // Update with actual image URL
  "description": "Rent a 35-seater AC bus for your corporate events, weddings, picnics, and group travel in Pune. Affordable, reliable, and comfortable bus rental services.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15650"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10000", // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/35-seater-ac-bus-on-rent-in-pune"
  }
};



    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | 35 Seater AC Bus on Rent in Pune | Corporate, Wedding & Picnic Travel</title>
  <meta 
    name="description" 
    content="Book a 35-seater AC bus on rent in Pune for weddings, corporate events, picnics, and group travel. Comfortable and affordable bus rental services in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(acBus35SeaterSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/83.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Thirtifiveseateracbus;